// extracted by mini-css-extract-plugin
export default {"container":"styles_container__U8oZJ","icon":"styles_icon__m+YuP","actions":"styles_actions__z9t-e"};